var map = {
	"./date-format.de-CH.json": 891,
	"./date-format.de-DE.json": 892,
	"./date-format.en-CA.json": 893,
	"./date-format.en-GB.json": 894,
	"./date-format.en-IN.json": 895,
	"./date-format.en-ME.json": 896,
	"./date-format.en-US.json": 897,
	"./date-format.es-EM.json": 898,
	"./date-format.es-ES.json": 899,
	"./date-format.fr-BE.json": 900,
	"./date-format.fr-CA.json": 901,
	"./date-format.fr-CH.json": 902,
	"./date-format.nl-BE.json": 903,
	"./date-format.nl-NL.json": 904,
	"./date-format.pl-PL.json": 905,
	"./date-format.pt-BR.json": 906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 890;